/**
 * Routes of the public bundle: the pages that must work without a login.
 *
 * Used by the public entry point (public-main.tsx). Only login and logout talk to the
 * identity provider, so only they are wrapped in it. All other routes redirect to login.
 */
import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { OidcAuthProvider } from '@bedc/client/auth/providers';
import { clientConstants } from '@bedc/client/constants';

import { LoginPage } from './pages/auth/LoginPage';
import { LogoutPage } from './pages/auth/LogoutPage';

/**
 * Loaded on demand, so the login page, which every user hits, doesn't download the UI library
 * and query client this page needs.
 */
const EmailUnsubscribePage = lazy(() =>
	import('./pages/email-unsubscribe/EmailUnsubscribePage').then((module) => ({
		default: module.EmailUnsubscribePage,
	}))
);

export const PublicApp = () => {
	return (
		<Routes>
			<Route
				path={clientConstants.auth.LoginPath}
				element={
					<OidcAuthProvider>
						<LoginPage />
					</OidcAuthProvider>
				}
			/>
			<Route
				path={clientConstants.auth.LogoutPath}
				element={
					<OidcAuthProvider>
						<LogoutPage />
					</OidcAuthProvider>
				}
			/>
			<Route
				path="/email-unsubscribe/:token"
				element={
					<Suspense>
						<EmailUnsubscribePage />
					</Suspense>
				}
			/>
			{/* Any other path redirects to login */}
			<Route path="*" element={<Navigate to={clientConstants.auth.LoginPath} replace />} />
		</Routes>
	);
};
